import React, { FC } from 'react';

import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Cancel, InfoOutlined } from '@mui/icons-material';

import { FormikProps } from 'formik';
import {
  CampaignImageField,
  getFileInfoFromUrl,
} from '../../../../../hooks/Admin/useUploadCampaignImages';
import CustomButton from '../../../../common/CustomButton';
import strings from '../../../../../localization';

import RecommendedTooltip from './RecommendedTooltip';
import styles from './styles';
import { formKeys } from '../../../../../helpers/Constants';

type handlers = (key: string) => () => void;

interface IUploadCampaignImageSection {
  field: CampaignImageField;
  fieldName: string;
  formik: FormikProps<any>;
  handlePickFile: (key: formKeys) => () => void;
  handleFileChange: (
    key: string,
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleOpenUri: handlers;
  onRemove: handlers;
  inputRefs: React.MutableRefObject<Record<formKeys, HTMLInputElement | null>>;
}

const UploadCampaignImageSection: FC<IUploadCampaignImageSection> = ({
  field,
  formik,
  fieldName,
  onRemove,
  inputRefs,
  handleOpenUri,
  handlePickFile,
  handleFileChange,
}) => {
  const value = formik.values[fieldName];
  const hasFile = !!value;

  return (
    <Box flex={6}>
      <Box sx={styles.row}>
        <Box sx={styles.actionsInline}>
          {hasFile && (
            <Box sx={styles.fileRow}>
              <Typography
                component="button"
                type="button"
                onClick={handleOpenUri(fieldName)}
                sx={styles.fileNameButton}
              >
                {getFileInfoFromUrl(value)?.name}
              </Typography>
              <IconButton onClick={onRemove(fieldName)} sx={styles.clearButton}>
                <Cancel sx={styles.clearIcon} />
              </IconButton>
            </Box>
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <CustomButton
              label={strings.uploadImage}
              onClick={handlePickFile(field.key)}
            />

            <Tooltip
              title={(
                <RecommendedTooltip
                  size={field.recommendedSize}
                  format="JPG, JPEG, PNG"
                  fileSizeMB={2}
                />
              )}
              placement="top"
            >
              <InfoOutlined sx={styles.infoIcon} />
            </Tooltip>
          </Box>
        </Box>
      </Box>

      <input
        type="file"
        accept="image/*"
        ref={(node) => {
          inputRefs.current[field.key] = node;
        }}
        style={styles.hiddenInput as React.CSSProperties}
        onChange={handleFileChange(fieldName)}
      />
    </Box>
  );
};
export default UploadCampaignImageSection;
